import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { AuthProvider } from "@descope/react-sdk";
import { Alert, AlertDescription, AlertTitle } from "@nxt-shared/ui/components/Alert";
import { GlobalLoading } from "./GlobalLoading.js";
import { environmentConfigUrl, loadEnvironmentConfig } from "./utils/environmentConfig.js";
// One request per page, shared by every provider on it (the widget bundle mounts two elements).
let pendingConfig;
function environmentConfig() {
    pendingConfig ??= loadEnvironmentConfig(environmentConfigUrl(import.meta.url)).catch((error) => {
        pendingConfig = undefined;
        throw error;
    });
    return pendingConfig;
}
export function PlatformBootError({ message }) {
    return _jsx("div", { className: "flex h-dvh items-center justify-center p-6", children: _jsxs(Alert, { variant: "danger", className: "max-w-lg", children: [_jsx(AlertTitle, { children: "Sign-in could not start" }), _jsx(AlertDescription, { children: message })] }) });
}
export function platformAuthView(state, props) {
    if (state.status === "loading")
        return _jsx(_Fragment, { children: props.loadingFallback ?? _jsx(GlobalLoading, {}) });
    if (state.status === "error")
        return _jsx(_Fragment, { children: props.errorFallback?.(state.message) ?? _jsx(PlatformBootError, { message: state.message }) });
    return _jsx(AuthProvider, { projectId: state.config.descopeProjectId, baseUrl: state.config.authBaseUrl, autoRefresh: true, children: props.children });
}
/** Descope's AuthProvider, configured from the environment that served this code (`/management/api/config`). */
export function PlatformAuthProvider(props) {
    const [state, setState] = useState({ status: "loading" });
    useEffect(() => {
        environmentConfig()
            .then((config) => setState({ status: "loaded", config }))
            .catch((error) => {
            console.error("Error loading environment config:", error);
            setState({ status: "error", message: error instanceof Error ? error.message : "Unknown error" });
        });
    }, []);
    return platformAuthView(state, props);
}
//# sourceMappingURL=PlatformAuthProvider.js.map